import { getPositionParams } from '../../../utils/animationsUtils';
const name = 'ModesMotionNoScale';
const properties = {
    groups: ['entrance', 'animation'],
    modeChange: true,
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
    },
};
/**
 * Shift animation object
 */
function animate(kit, elements, duration, delay, { from, ...params }) {
    const sequence = kit.sequence(params);
    const { width, height, rotation } = from;
    elements.forEach((element) => {
        const elementViewPortDim = kit.engine.getBoundingRect(element);
        const positionParams = getPositionParams(elementViewPortDim, from);
        sequence.add(kit.animate('BasePosition', element, duration, delay, {
            from: positionParams,
            ease: 'Cubic.easeInOut',
        }), 0);
        sequence.add(kit.animate('BaseDimensions', element, duration, delay, {
            from: { width, height },
            ease: 'Cubic.easeInOut',
        }), 0);
        sequence.add(kit.animate('BaseRotate', element, duration, delay, {
            from: { rotation },
            ease: 'Cubic.easeInOut',
        }), 0);
    });
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=ModesMotionNoScale.js.map